export default "__VITE_ASSET__CpN4ohi2__"